import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IScanPackageToMoveFromBlackboxData } from '../../../types';

/**
 * This is to track the mutation key for scan package to move from blackbox to
 * open inbound transaction.
 */
const MUT_SCAN_PACKAGE_TO_REMOVE =
  'scan-package-to-move-from-blackbox-mutation-key';

interface IScanPackageToMoveFromBlackboxParam {
  onSuccess: (updatedBidsData: IScanPackageToMoveFromBlackboxData) => void;
  onError: (err: IApiError) => void;
}

/**
 * React Query mutation function for moving a package from black box an open
 * inbound transaction.
 */
export const useScanPackageToMoveFromBlackboxMutation = ({
  onSuccess,
  onError,
}: IScanPackageToMoveFromBlackboxParam) => {
  const { isPending, isError, error, data, mutate, reset } = useMutation({
    mutationKey: [MUT_SCAN_PACKAGE_TO_REMOVE],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.scanPackageToMoveFromBlackbox,
    onSuccess,
    onError,
  });

  return {
    data,
    error,
    isError,
    isPending,
    resetScanPackageToMoveFromBlackbox: reset,
    scanPackageToMoveFromBlackbox: mutate,
  };
};
